import { type VuetifyOptions } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg';
import { de, en, fr, it } from 'vuetify/locale';

import { getPreferredLanguage } from '@abaninja/util-i18n';

import { brandColors } from './brand-colors';

const inputDefault = {
  color: 'primary',
  density: 'comfortable',
  variant: 'outlined',
};

export const vuetifyOptions: VuetifyOptions = {
  defaults: {
    VAlert: {
      variant: 'tonal',
      VBtn: {
        variant: 'tonal',
      },
    },
    VAppBar: {
      elevation: 0,
    },
    VAutocomplete: {
      ...inputDefault,
    },
    VBtn: {
      elevation: 0,
    },
    VCard: {
      border: true,
      elevation: 0,
      VCardActions: {
        VBtn: {
          variant: 'flat',
        },
      },
    },
    VCheckbox: {
      color: 'primary',
    },
    VCombobox: {
      ...inputDefault,
      delimiters: [','],
    },
    VDialog: {
      maxWidth: 500,
      VCard: {
        VCardActions: {
          class: 'justify-end',
        },
      },
    },
    VHotkey: {
      variant: 'tonal',
    },
    VMenu: {
      VCard: {
        border: false,
        elevation: 8,
      },
    },
    VNumberInput: {
      ...inputDefault,
      controlVariant: 'stacked',
    },
    VRadioGroup: {
      color: 'primary',
      density: 'comfortable',
    },
    VSelect: {
      ...inputDefault,
    },
    VStepper: {
      flat: true,
      VStepperItem: {
        color: 'primary',
      },
    },
    VSwitch: {
      color: 'primary',
      density: 'compact',
      hideDetails: 'auto',
    },
    VTextarea: {
      ...inputDefault,
    },
    VTextField: {
      ...inputDefault,
    },
    VTooltip: {
      location: 'bottom center',
    },
  },
  icons: {
    aliases,
    defaultSet: 'mdi',
    sets: {
      mdi,
    },
  },
  locale: {
    fallback: 'en',
    locale: getPreferredLanguage(),
    messages: { de, en, fr, it },
  },
  theme: {
    themes: {
      dark: {
        dark: true,
        colors: {
          'on-primary': '#FFFFFF',
          'on-secondary': '#000000',

          // Primary Blue Color
          'primary': '#128ef2',
          // secondary Color
          'secondary': '#ffffff',
          ...brandColors,
        },
      },
      light: {
        dark: false,
        colors: {
          'background': '#f8f9fa',

          'on-primary': '#FFFFFF',
          'on-secondary': '#ffffff',

          // Primary Blue Color
          'primary': '#128ef2',

          // secondary Color
          'secondary': '#000000',
          ...brandColors,
        },
      },
    },
    variations: {
      colors: ['primary', 'secondary'],
      darken: 2,
      lighten: 1,
    },
  },
};
